export const enum SortModalType {
  CANCEL = 'CANCEL',
  CONFIRM = 'CONFIRM',
  SCAN = 'SCAN'
}
